import { Container } from 'ui/container'
import { MarketingList } from 'features/admin/marketing'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminMarketingPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Маркетинговые рассылки</span>
            </div>
            <Container>
                <MarketingList />
            </Container>
        </div>
    )
}

export default AdminMarketingPage
